<template>
  <v-container>
    <v-card :height="$vuetify.breakpoint.height-90" style="overflow-y: auto;">

      <v-row>
        <v-col>
          <v-card :max-height="$vuetify.breakpoint.height-115" style="overflow-y: auto;" flat tile>

            <v-treeview v-model="selection" :items="items" :selection-type="selectionType" selectable return-object></v-treeview>
          </v-card>

        </v-col>
        <v-divider vertical></v-divider>
        <v-col class="pa-6" cols="6">
          <v-card :max-height="$vuetify.breakpoint.height-115" style="overflow-y: auto;" flat tile>

            <template v-if="!selection.length">

              No nodes selected.
            </template>
            <template v-else>
              <div v-for="node in selection" :key="node.id">
                <template v-for="item in node.children">
                  Translate: {{$language[node.name][item.name]}}
                  <div v-if="item.children" :key="item.id">
                    <template v-for="(subItem) in item.children">
                      Translate: {{subItem.name}}

                      <v-textarea rows="2" outlined :key="subItem.id" @input="save($event,subItem.id,subItem.name )" v-model="((userProfile.translate||{})[subItem.id]||{}).text"></v-textarea>

                    </template>
                  </div>
                  <v-textarea rows="2" outlined :key="item.id" v-else @input="save($event,item.id,item.name )" v-model="((userProfile.translate||{})[item.id]||{}).text"></v-textarea>
                </template>
              </div>
            </template>
          </v-card>

        </v-col>
      </v-row>
    </v-card>

  </v-container>
</template>

<script>
import {
  mapState
} from 'vuex'
const fb = require('@/services/firebaseConfig.js')

export default {

  data () {
    return {
      selectionType: 'independent',
      selection: []
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'userJobs', 'jobLoading']),
    items () {
      var id = 2
      return Object.keys(this.$language).map(k => {
        id = id + 1
        return {
          name: k,
          id: id,
          hasChildren: true,
          children: Object.keys(this.$language[k]).map(l => {
            id = id + 1

            if (Array.isArray(this.$language[k][l]) || typeof this.$language[k][l] === 'object') {
              console.log(k, l, this.$language[k][l])
              if (Array.isArray(this.$language[k][l])) {
                return {
                  name: l,
                  children: Object.values(this.$language[k][l]).map(m => {
                    id = id + 1
                    return {
                      id: id,
                      name: m,
                      locked: true
                    }
                  }),
                  hasChildren: true,
                  id: id
                }
              } else {
                return {
                  name: l,
                  children: Object.keys(this.$language[k][l]).map(m => {
                    id = id + 1
                    return {
                      id: id,
                      name: m,
                      locked: true
                    }
                  }),
                  hasChildren: true,
                  id: id
                }
              }
            } else {
              id = id + 1
              return {
                name: l,
                id: id,
                locked: true
              }
            }
          })
        }
      })
    }
  },
  mounted () {},
  methods: {
    save (event, id, key) {
      var updates = {}

      clearTimeout(this._timerId)
      // delay new call 500ms
      this._timerId = setTimeout(() => {
        updates[`/user/${this.currentUser.uid}/profile/translate/${id}`] = {
          text: event,
          _key: key
        }
        fb.database.ref().update(updates)
      }, 100)
    }
  },
  watch: {}
}
</script>
